import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CompanyCreate } from './create';
import { CompanyDetails } from './details';
import { CompanyEdit } from './edit';
import { CompaniesOverview } from './overview';
import { CompanyProductsOverview } from "../../products/pages/companyProducts/overview";
import { CompanyProductDetails } from "../../products/pages/companyProducts/companyProductDetails";

const Container = styled.div`
  .form-block {
    display: flex;
    align-items: stretch;
    flex-direction: row;
    gap: 3px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .pane {
    background-color: white;
    padding: 24px;
    min-height: 800px;
    height: 100%;

    h2 {
      font-size: 14px;
      text-transform: uppercase;
    }

    @media (max-width: 768px) {
      min-height: auto;
    }

    h2 {
      margin-bottom: 24px;
    }

    .cols {
      gap: 48px;
      align-self: stretch;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompaniesPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/companies/create/:step/:company_id?"
            render={(component) => <CompanyCreate step={parseInt(component.match.params.step, 10)} />}
          />

          <Route
            path="(.*)/companies/:id/edit/:step?"
            render={(component) => (
              <CompanyEdit
                key={`${component.match.params.id}-${component.match.params.step}`}
                company_id={parseInt(component.match.params.id, 10)}
                step={parseInt(component.match.params.step, 10)}
              />
            )}
          />
          <Route
            path="/companies/:id/products/:product_id"
            render={component => (
              <CompanyProductDetails
                companyId={component.match.params.id}
                productId={component.match.params.product_id}
              />
            )}
          />
          <Route
            path="/companies/:id/products"
            render={component => (
              <CompanyProductsOverview
                company_id={component.match.params.id}
              />
            )}
          />
          <Route
            path="(.*)/companies/:id(.*)"
            render={(component) => (
              <CompanyDetails company_id={component.match.params.id.split('/').shift()} countries={this.props.countries} />
            )}
          />
          <Route component={CompaniesOverview} />
        </Switch>
      </Container>
    );
  }
}

CompaniesPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompaniesPage = compose(withConnect, withRouter)(CompaniesPageComp);
